import { useEffect } from 'react';

export function IntroScreen() {
  // Lock body scroll when visible
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className="fixed inset-0 z-[100] bg-background flex flex-col items-center justify-center animate-fade-in">
      {/* Main headline */}
      <h1 className="text-3xl font-serif font-bold text-foreground text-center">
        💯 Drinks
      </h1>
      
      {/* Subheadline */}
      <p className="text-muted-foreground text-sm mb-8">365 Days</p>

      {/* Loading indicator */}
      <div className="flex items-center gap-2">
        <span className="w-2 h-2 bg-primary rounded-full animate-pulse" style={{ animationDelay: '0ms' }} />
        <span className="w-2 h-2 bg-primary rounded-full animate-pulse" style={{ animationDelay: '150ms' }} />
        <span className="w-2 h-2 bg-primary rounded-full animate-pulse" style={{ animationDelay: '300ms' }} />
      </div>
    </div>
  );
}
